import { GANTT_STYLE_MODE } from '../../../../../../components/GanttVisualization/constants';

export const getCssGanttBarFormat = (gantt) => {
  if (gantt.barFormat === GANTT_STYLE_MODE.BARS) {
    return '';
  }

  return `
    /* GANTT VISUALIZATION STYLES */

    /* TASK BAR STYLES */
    /* Main task bar styling */
    div.activitytask-bar-custom-style {
        border: 0px solid !important;
        border-radius: 0px;
        z-index: initial;
        border-left: 2px solid #b3b3b3 !important;
        box-sizing: border-box;
        border: 0 !important;
        margin: 0 !important;
        margin-top: -2px !important;
    }

    div.main-bar-custom-style,
    div.new-project-gantt-style,
    .gantt_task_line.gantt_milestone {
        z-index: 3;
    }

    div.main-bar-custom-style {
        margin-top: 10px !important;
    }

    div.main-bar-custom-style.gantt_selected {
        z-index: 3 !important;
    }

    /* PARENT TASK STYLES */
    div.parent-task-style {
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
        background: transparent !important;
        height: 20px !important;
        background-color: var(--borderMarkersColor);
        border: none !important;
        box-shadow: none;
        --task-height: 20px;
        --triangle-width: 7px;
    }

    div div.gantt_task_cell {
        z-index: initial;
        border: none !important;
    }

    div div.gantt_task_cell::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: -1px;
        border-right: 1px solid #d8d8d8 !important;
        z-index: 4;
        pointer-events: none;
    }

    div.parent-task-style
    .gantt_task_progress_wrapper {
        height: var(--task-height);
        background-color: var(--backgroundColor) !important;
        clip-path: polygon(
            0 0,
            100% 0,
            100% 100%,
            calc(100% - var(--triangle-width))
            calc(var(--task-height) - var(--triangle-width)),
            var(--triangle-width) calc(var(--task-height) - var(--triangle-width)),
            0 100%
        );
        overflow: hidden;
        border-radius: 0px;
        z-index: 3 !important;
        top: 8px;
    }

    .parent-task-style:before,
    .parent-task-style:after {
        display: none;
    }

    
    div.parent-task-style
    .gantt_side_content.gantt_right {
        top: -4px !important;
        z-index: 4;
    }

    /* CELL AND GRID STYLES */
    div.gantt_task_cell {
        z-index: 4 !important;
        border-left: 1px solid #d8d8d8 !important;
    }

    div.gantt_task_cell::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
    }

    /* WEEKEND STYLES */
    div.personalized-weekend-class-visua {
        background-color: #f0f4f5 !important;
        z-index: initial !important;
        border: none !important;
    }

    div.personalized-weekend-class-visua::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
        pointer-events: none;
        width: 100%;
        background: #f0f4f5;
    }

    /* SIDE CONTENT STYLES */
    .gantt_side_content.gantt_right {
        position: inherit;
        top: 0 !important;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        z-index: 3;
    }

    /* MARKER AND RANGE STYLES */
    div.gantt_marker_content,
    div.weekly-range {
        z-index: 3;
        pointer-events: none;
    }

    div.today-custom-timeline {
        z-index: 3;
    }

    /* SELECTION STATES */
    
    div.gantt_task_line.gantt_task_inline_color.gantt_project.gantt_selected,
    div.gantt_task_line.gantt_task_inline_color.gantt_selected {
        box-shadow: none;
        z-index: initial;
    }

    div.gantt_task_line.gantt_task_inline_color.gantt_selected
    .gantt_task_progress_wrapper {
        z-index: 0;
    }

    div.gantt_task_row.gantt_selected
    .gantt_task_cell {
        background-color: transparent !important;
        border-right-color: #d8d8d8;
        z-index: 4 !important;
    }

    div.gantt_task_row.gantt_selected
    .personalized-weekend-class-visua {
        background-color: #f0f4f5 !important;
        z-index: initial !important;
    }

    div.gantt_task_bg .gantt_task_row {
        border-bottom: 1px solid #d8d8d8  !important;
    }

  `;
};
